// Placeholder
"use client";
import { usePowerSearch } from "../contexts/power-search-context";
import { useState } from "react";
import Button from "react-bootstrap/Button";
import { useSelector } from "react-redux";
import { mixpanelTrack } from "shared/trackEvents/mixpanelTracking";
import { isOpenRemunerationPlan } from "shared/plans";
import {
  POWER_SEARCH_EVENT_NAMES,
  MIXPANEL_PROPS,
} from "shared/trackEvents/constants";

const GenderFilter = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const currentUser = useSelector((state) => state.users.user);
  const { gender, updateFilter } = usePowerSearch();
  const genders = [
    { label: "All", value: "all" },
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
  ];

  return (
    <div className="">
      <div
        className="d-flex align-items-center mb-2"
        style={{ cursor: "pointer" }}
        onClick={() => setIsExpanded((prev) => !prev)}
      >
        <Button
          variant="link"
          size="sm"
          style={{
            display: "inline-block",
            padding: 0,
            margin: 0,
            textDecoration: "none",
            marginRight: "4px",
            focus: "none",
            outline: "none",
            border: "none",
            boxShadow: "none",
            fontWeight: "bold",
          }}
        >
          {isExpanded ? "−" : "+"}
        </Button>
        <p
          style={{
            fontSize: "14px",
            fontWeight: "bold",
            margin: 0,
          }}
        >
          GENDER{" "}
        </p>
      </div>
      <div className={`${isExpanded ? "d-block" : "d-none"}`}>
        {genders.map((g) => (
          <div
            key={g.value}
            className="d-flex col-gap-1 align-items-center mb-1"
          >
            <div className="">
              {/* Assuming .round CSS for custom radio */}
              <input
                type="radio"
                id={`gender-${g.value}`}
                name="genderFilter" // Ensure same name for radio group
                value={g.value}
                checked={gender === g.value}
                onChange={(e) => {
                  updateFilter("gender", e.target.value);

                  // Track gender filter selection
                  const eventName = isOpenRemunerationPlan(currentUser)
                    ? POWER_SEARCH_EVENT_NAMES.OR_POWER_SEARCH_FILTER_GENDER_CLICKED
                    : POWER_SEARCH_EVENT_NAMES.OD_POWER_SEARCH_FILTER_GENDER_CLICKED;

                  mixpanelTrack(eventName, {
                    [MIXPANEL_PROPS.FILTER_OPTION]: e.target.value,
                    userEmail: currentUser?.email,
                  });
                }}
              />
              <label htmlFor={`gender-${g.value}`}></label>
            </div>
            <label
              className="mb-0 ms-2 ml-1 text-capitalize"
              htmlFor={`gender-${g.value}`}
              style={{ flex: 1, fontSize: "14px", fontWeight: "500" }}
            >
              {g.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};
export default GenderFilter;
